var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-padding" }, [
    _c(
      "div",
      {
        staticClass: "billing-address",
        staticStyle: { "margin-bottom": "60px" }
      },
      [
        _c("h5", [_vm._v(" Billing Address ")]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              { staticClass: "q-pa-md col-12" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Address 1",
                    value: _vm.billingAddressForm.ADDRESS_1,
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              { staticClass: "q-pa-md col-12" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Address 2",
                    value: _vm.billingAddressForm.ADDRESS_2,
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.billingAddressForm.CITY.$error,
                  "error-label": "City required"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "City",
                    value: _vm.billingAddressForm.CITY,
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.billingAddressForm.LK_STATE_ID.$error,
                  "error-label": "State required"
                }
              },
              [
                _c("q-select", {
                  ref: "billingStateDropdown",
                  attrs: {
                    "float-label": "State",
                    value: _vm.billingAddressForm.LK_STATE_ID,
                    disable: true,
                    filter: "",
                    "autofocus-filter": "",
                    options: _vm.stateOptions
                  },
                  on: {
                    focus: function($event) {
                      _vm.onDropdownFocus("billingStateDropdown")
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "q-field",
              {
                staticClass: "q-pa-md col-4",
                attrs: {
                  error: _vm.validation.billingAddressForm.ZIP_CODE.$error,
                  "error-label": "Requires 5 numeric characters"
                }
              },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": "Zip",
                    value: _vm.billingAddressForm.ZIP_CODE,
                    disable: true,
                    required: ""
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    ),
    _c("div", { staticClass: "shipping-address" }, [
      _c(
        "h5",
        [
          _vm._v("Mailing Address "),
          _c("q-checkbox", {
            staticStyle: { "margin-left": "20px" },
            attrs: { disable: true },
            on: {
              input: function(val) {
                return _vm.setSameAsBilling({ status: val })
              }
            },
            model: {
              value: _vm.shippingAddressForm.sameAsBilling,
              callback: function($$v) {
                _vm.$set(_vm.shippingAddressForm, "sameAsBilling", $$v)
              },
              expression: "shippingAddressForm.sameAsBilling"
            }
          }),
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "13px",
                display: "inline-block",
                "vertical-align": "middle",
                "margin-left": "5px"
              }
            },
            [_vm._v("Same as Billing")]
          )
        ],
        1
      ),
      !_vm.shippingAddressForm.sameAsBilling
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "q-field",
                  { staticClass: "q-pa-md col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": "Address 1",
                        value: _vm.shippingAddressForm.ADDRESS_1,
                        disable: true,
                        required: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "q-field",
                  { staticClass: "q-pa-md col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": "Address 2",
                        value: _vm.shippingAddressForm.ADDRESS_2,
                        disable: true,
                        required: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "q-field",
                  {
                    staticClass: "q-pa-md col-4",
                    attrs: {
                      error: _vm.validation.shippingAddressForm.CITY.$error,
                      "error-label": "City required"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": "City",
                        value: _vm.shippingAddressForm.CITY,
                        disable: true,
                        required: ""
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-field",
                  {
                    staticClass: "q-pa-md col-4",
                    attrs: {
                      error:
                        _vm.validation.shippingAddressForm.LK_STATE_ID.$error,
                      "error-label": "State required"
                    }
                  },
                  [
                    _c("q-select", {
                      ref: "shippingStateDropdown",
                      attrs: {
                        "float-label": "State",
                        value: _vm.shippingAddressForm.LK_STATE_ID,
                        filter: "",
                        "autofocus-filter": "",
                        options: _vm.stateOptions,
                        disable: true
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-field",
                  {
                    staticClass: "q-pa-md col-4",
                    attrs: {
                      error: _vm.validation.shippingAddressForm.ZIP_CODE.$error,
                      "error-label": "Requires 5 numeric characters"
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": "Zip",
                        value: _vm.shippingAddressForm.ZIP_CODE,
                        disable: true,
                        required: ""
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }